export const SUBMIT_BUTTON_LABEL = 'Send';
